<template>
  <div class="forgetBox">
    <div class="forgetArea">
      <el-steps :active="stopActive" simple>
        <el-step title="手机号验证" icon="el-icon-edit"></el-step>
        <el-step title="重置密码" icon="el-icon-finished"></el-step>
        <el-step title="设置成功" icon="el-icon-check"></el-step>
      </el-steps>
      <div class="box" v-if="stopActive === 1">
        <el-form ref="form" class="formBox" :model="form" label-width="130px">
          <el-form-item label="请输入手机号码">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="请输入验证码">
            <div class="flex center-row lineYzm">
              <el-input v-model="form.value"></el-input>
              <el-button type="warning" :disabled="disabled" @click="sendcode" class="sendcode">{{ btntxt }}</el-button>
            </div>
          </el-form-item>
          <el-form-item label=" ">
              <el-button type="primary" @click="OK" class="confirmBtn">确定</el-button>
          </el-form-item>
          
        </el-form>
      </div>

      <div class="box" v-if="stopActive === 2">
        <el-form ref="form" class="formBox" :model="form" label-width="130px">
          <el-form-item label="请输入新密码">
            <el-input type="password" v-model="form.newPassword"></el-input>
          </el-form-item>
          <el-form-item label="再次确认新密码">
            <el-input type="password" v-model="form.confirmPassword"></el-input>
          </el-form-item>
          <el-form-item label=" ">
              <el-button type="primary" @click="modify" class="confirmBtn">确定</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="box" v-if="stopActive === 3">
         <div class="suss">
            <i class="el-icon-circle-check mt50"></i> <br>
            <span class="mt20 fz12 cm">修改成功</span><br>
            <el-button type="primary" @click="toLogin" class="confirmBtn mt50">去登录>></el-button>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
import {sendValidate,validateMessage,updatePassword} from '@/api/user'
import website from '@/config/website';
import md5 from 'js-md5'
export default {
  data: function () {
    return {
      stopActive: 1,
      disabled: false,
      time: 60,
      btntxt: '发送验证码',
      code: 'ali-validate',
      id: '',
      form:{
        phone: '',
        value: '',
        newPassword: '',
        confirmPassword: ''
      }
    };
  },
  methods: {
    sendcode() {
      this.time = 60;
      if (!this.form.phone) {
        this.$message.error('请输入手机号码')
        return
      }
      sendValidate({phone: this.form.phone, code: this.code,tenantId: website.tenantId}).then(res=>{
        console.log(res)
        this.timer();
        if (res.data.code == 200) {
          this.id =res.data.data.id
          this.$message.success('短信发送成功')
        }
      })
    },
    //发送手机验证码倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        this.time--;
        this.btntxt = this.time + '秒';
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = '发送验证码';
        this.disabled = false;
      }
    },
    OK () {
      validateMessage({code:  this.code,value: this.form.value,id: this.id,tenantId: website.tenantId}).then(res=>{
        console.log(res)
        this.stopActive = 2
      })
    },
    modify () {
      if (this.form.newPassword.length<6) {
        this.$message.error('密码最小为6位')
        return
      }
      if (this.form.confirmPassword !== this.form.newPassword) {
        this.$message.error('密码不一致，请重新输入')
        return
      }
      updatePassword({phone:  this.form.phone,tenantId: website.tenantId,newPassword: md5(this.form.newPassword)}).then(res=>{
        console.log(res)
        this.stopActive = 3
      })
    },
    toLogin () {
      this.$router.push({ path: '/login' });
    }
  }
};
</script>

<style lang="scss" scope>
.forgetArea {
  margin: 0px auto 0;width: 80%;
  padding-top: 120px;;
  }
  
.formBox{
  width:40%;margin: 40px auto 0;
   .lineYzm{
     .el-button{width: 120px;;}
   }
}
  .lineYzm .el-input {
  flex:1
}
.confirmBtn{
  width: 60%;margin: 20px 0% 0;
}
.suss{text-align: center;
  .el-icon-circle-check{font-size: 60px;color: #01aaa7;;}
  .el-button{width: 120px;;}
}
</style>
